export function outlookLink(
  startDateTime: string,
  subject: string,
  location: string,
) {
  // outlook() from calendar-link uses outlook.live.com which doesn't seem to work
  return `https://outlook.office.com/calendar/0/action/compose?rru=addevent&startdt=${startDateTime}&subject=${subject}&location=${location}&allday=false`;
}
